import React from 'react';
import { motion } from 'framer-motion';
import { Droplets, HeartCrack, Brain, PenTool, RefreshCw, Sparkles, ArrowRight } from 'lucide-react';
export function StorySection() {
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-210">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-30 pointer-events-none" data-id="element-211">
        <div className="absolute top-20 -left-32 w-96 h-96 rounded-full bg-[#FAF5E9] blur-3xl" data-id="element-212"></div>
        <div className="absolute bottom-20 -right-32 w-96 h-96 rounded-full bg-[#FAF5E9] blur-3xl" data-id="element-213"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-214">
        {/* MICRO ANCLA DE AUTORIDAD */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-24 text-center max-w-3xl mx-auto bg-stone-50 p-8 md:p-10 rounded-3xl border border-stone-200 shadow-sm" data-id="element-215">
          <p className="text-stone-600 text-lg md:text-xl leading-relaxed mb-6" data-id="element-216">
            Este sistema no nació de teoría… <br className="hidden md:block" data-id="element-217" />
            nació de observar un patrón repetido en miles de mujeres:
          </p>
          <p className="text-stone-900 font-bold text-xl md:text-2xl leading-relaxed mb-6" data-id="element-218">
            no era falta de esfuerzo… era una forma inconsciente de relacionarse
            con el dinero.
          </p>
          <p className="text-[#C5A059] font-bold italic font-serif text-2xl" data-id="element-219">
            Y cuando ese patrón cambia… todo empieza a reorganizarse.
          </p>
        </motion.div>

        {/* 3. MECANISMO */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-24" data-id="element-220">
          <div className="text-center mb-12" data-id="element-221">
            <span className="inline-block py-1 px-3 rounded-full bg-stone-100 text-stone-600 text-sm font-bold tracking-wider uppercase mb-4" data-id="element-222">
              Cómo funciona realmente
            </span>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-6" data-id="element-223">
              Esto NO es motivación.
            </h2>
            <p className="text-stone-600 text-lg" data-id="element-224">
              Funciona en 3 niveles específicos:
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-225">
            <div className="bg-[#F9F9F7] p-8 rounded-2xl border border-stone-100" data-id="element-226">
              <Brain className="w-8 h-8 text-[#C5A059] mb-4" data-id="element-227" />
              <h3 className="font-bold text-stone-900 mb-2" data-id="element-228">
                1. Reprogramación mental
              </h3>
              <p className="text-stone-600 text-sm leading-relaxed" data-id="element-229">
                Detectas y reemplazas creencias automáticas que te mantienen
                estancada.
              </p>
            </div>
            <div className="bg-[#F9F9F7] p-8 rounded-2xl border border-stone-100" data-id="element-230">
              <PenTool className="w-8 h-8 text-[#C5A059] mb-4" data-id="element-231" />
              <h3 className="font-bold text-stone-900 mb-2" data-id="element-232">
                2. Reescritura interna
              </h3>
              <p className="text-stone-600 text-sm leading-relaxed" data-id="element-233">
                Cambias tu narrativa frente al dinero para dejar de repelerlo.
              </p>
            </div>
            <div className="bg-[#F9F9F7] p-8 rounded-2xl border border-stone-100" data-id="element-234">
              <RefreshCw className="w-8 h-8 text-[#C5A059] mb-4" data-id="element-235" />
              <h3 className="font-bold text-stone-900 mb-2" data-id="element-236">
                3. Nuevos patrones
              </h3>
              <p className="text-stone-600 text-sm leading-relaxed" data-id="element-237">
                Dejas de sabotear ingresos sin darte cuenta y tomas decisiones
                desde la abundancia.
              </p>
            </div>
          </div>

          <p className="text-center text-xl font-serif italic text-stone-800 mt-10" data-id="element-238">
            Porque el problema no es el dinero…{' '}
            <strong className="text-[#C5A059]" data-id="element-239">
              es cómo reaccionas ante él en automático.
            </strong>
          </p>
          <p className="text-center text-lg text-stone-600 mt-6 max-w-2xl mx-auto" data-id="element-240">
            Este sistema no es para cualquiera… es para mujeres que saben que
            pueden más… pero sienten que algo interno las está frenando.
          </p>

          {/* PRUEBA VISUAL / LÓGICA RÁPIDA */}
          <div className="mt-12 bg-stone-50 rounded-2xl p-8 border border-stone-200 max-w-2xl mx-auto text-left shadow-sm" data-id="element-241">
            <h4 className="text-xl font-serif font-bold text-stone-900 mb-6 flex items-center gap-2" data-id="element-242">
              <span className="text-[#C5A059]" data-id="element-243">🔍</span> ¿Cómo se ve esto en la
              vida real?
            </h4>
            <div className="space-y-6" data-id="element-244">
              <div data-id="element-245">
                <p className="text-sm font-bold text-stone-500 uppercase tracking-wider mb-2" data-id="element-246">
                  Antes:
                </p>
                <p className="text-stone-700 font-medium" data-id="element-247">
                  Ganas dinero → sientes ansiedad → tomas malas decisiones →
                  vuelves a empezar
                </p>
              </div>
              <div data-id="element-248">
                <p className="text-sm font-bold text-[#C5A059] uppercase tracking-wider mb-2" data-id="element-249">
                  Después:
                </p>
                <p className="text-stone-900 font-bold" data-id="element-250">
                  Ganas dinero → sientes calma → decides con claridad → el
                  dinero se queda
                </p>
              </div>
            </div>
            <p className="mt-6 pt-6 border-t border-stone-200 text-stone-600 italic font-medium mb-8" data-id="element-251">
              👉 No cambió el dinero. Cambió tu sistema.
            </p>

            {/* IMPULSE CTA */}
            <div className="flex justify-center" data-id="element-252">
              <a href="https://pay.hotmart.com/L105538443T" target="_blank" rel="noopener noreferrer" onClick={() => {
              if ((window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout');
              }
            }} className="group relative inline-flex items-center justify-center gap-3 px-8 py-4 text-base font-bold text-stone-900 rounded-full overflow-hidden shadow-[0_0_20px_rgba(197,160,89,0.3)] transition-all hover:shadow-[0_0_40px_rgba(197,160,89,0.5)] hover:scale-105 w-full md:w-auto" data-id="element-253">
                <div className="absolute inset-0 gold-gradient" data-id="element-254"></div>
                <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-255"></div>
                <span className="relative flex items-center gap-2 text-center" data-id="element-256">
                  👉 Quiero sentir este cambio
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform shrink-0" data-id="element-257" />
                </span>
              </a>
            </div>
          </div>
        </motion.div>

        {/* 4. DOLOR + IDENTIFICACIÓN */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-24 max-w-3xl mx-auto" data-id="element-258">
          <div className="flex justify-center mb-6" data-id="element-259">
            <HeartCrack className="w-10 h-10 text-[#C5A059] opacity-80" data-id="element-260" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-8 leading-tight" data-id="element-261">
            Sabes exactamente de qué hablo…
          </h2>
          <div className="space-y-6 text-stone-600 text-lg leading-relaxed text-left md:text-center" data-id="element-262">
            {/* EFECTO LECTURA RÁPIDA */}
            <div className="flex flex-col items-start md:items-center gap-3 mb-6" data-id="element-263">
              <p className="flex items-center gap-2" data-id="element-264">
                <span className="text-[#C5A059]" data-id="element-265">▪</span> Ese nudo en el
                estómago cuando llegan las cuentas
              </p>
              <p className="flex items-center gap-2" data-id="element-266">
                <span className="text-[#C5A059]" data-id="element-267">▪</span> Las discusiones por
                dinero
              </p>
              <p className="flex items-center gap-2" data-id="element-268">
                <span className="text-[#C5A059]" data-id="element-269">▪</span> El cansancio de
                trabajar sin ver resultados
              </p>
            </div>

            <p className="italic text-stone-500" data-id="element-270">
              Y esa sensación incómoda de pensar: <br data-id="element-271" />
              <span className="text-stone-800 font-medium" data-id="element-272">
                “¿Por qué parece tan fácil para otros… y tan pesado para mí?”
              </span>
            </p>
            <div className="pt-6" data-id="element-273">
              <p className="font-serif text-2xl text-[#A8823A] mb-2" data-id="element-274">
                Respira…
              </p>
              <p className="font-medium text-stone-900" data-id="element-275">
                Ese dolor no es tu destino. Es un patrón… y los patrones se
                pueden cambiar.
              </p>
            </div>
          </div>
        </motion.div>

        {/* 5. HISTORIA (RÍO) */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-[#FAF5E9] rounded-3xl p-8 md:p-12 shadow-sm border border-[#C5A059]/10 relative mb-24" data-id="element-276">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md border border-stone-100" data-id="element-277">
            <Droplets className="w-6 h-6 text-[#C5A059]" data-id="element-278" />
          </div>

          <h3 className="text-2xl md:text-3xl font-serif font-bold text-stone-900 mb-8 text-center mt-4" data-id="element-279">
            Imagina esto…
          </h3>

          <div className="space-y-6 text-stone-700 text-lg leading-relaxed" data-id="element-280">
            <p className="text-center font-medium" data-id="element-281">
              El dinero es como un río constante. Siempre está fluyendo.
            </p>
            <p data-id="element-282">Pero hay dos formas de relacionarte con él:</p>
            <div className="pl-4 border-l-2 border-[#C5A059]/30 space-y-4 my-6" data-id="element-283">
              <p data-id="element-284">
                <strong className="text-stone-900" data-id="element-285">Una…</strong> lucha, se
                desespera, intenta controlarlo… y termina agotada, con las manos
                vacías.
              </p>
              <p data-id="element-286">
                <strong className="text-stone-900" data-id="element-287">La otra…</strong> entiende el
                sistema. No persigue el agua… crea el recipiente. Y desde ahí…
                el flujo se vuelve natural.
              </p>
            </div>
            <p className="font-bold text-stone-900 text-center pt-4 text-xl font-serif" data-id="element-288">
              👉 La diferencia no es esfuerzo. Es estructura interna.
            </p>
          </div>
        </motion.div>

        {/* VISUAL ENHANCEMENT (CALM + ABUNDANCE) */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-16 rounded-3xl overflow-hidden shadow-2xl border border-stone-200 max-w-4xl mx-auto" data-id="element-289">
          <img src="https://cdn.magicpatterns.com/uploads/ifqHrUucDXQvQeoYXfNNK3/Imagen_referencia_6.png" alt="Manos recibiendo luz y abundancia" className="w-full h-64 md:h-96 object-cover object-center" data-id="element-290" />
        </motion.div>

        {/* 6. MICRO TRANCE */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="text-center bg-gradient-to-b from-white to-[#F9F9F7] p-12 rounded-3xl border border-stone-100 shadow-[0_10px_40px_rgba(0,0,0,0.03)]" data-id="element-291">
          <Sparkles className="w-8 h-8 text-[#C5A059] mx-auto mb-6 opacity-60" data-id="element-292" />
          <p className="text-xl text-stone-600 mb-6" data-id="element-293">
            Y en este momento… puedes empezar a notar algo…
          </p>

          <div className="space-y-4 text-2xl md:text-3xl font-serif text-stone-800 leading-relaxed mb-8" data-id="element-294">
            <p data-id="element-295">
              ¿Qué pasaría si dejaras de sentir presión cada vez que piensas en
              dinero?
            </p>
            <p data-id="element-296">¿Qué cambiaría… si confiaras en que puedes sostener más?</p>
          </div>

          <div className="space-y-2 text-lg text-stone-600" data-id="element-297">
            <p data-id="element-298">Imagina abrir tu cuenta…</p>
            <p data-id="element-299">y en lugar de tensión…</p>
            <p className="font-bold text-[#C5A059] text-xl my-4" data-id="element-300">
              sentir control. Calma. Certeza.
            </p>
            <p className="italic text-stone-800 font-serif text-2xl mt-6" data-id="element-301">
              Y algo dentro de ti diciendo: <br data-id="element-302" />
              "Ahora sí… esto es diferente."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}